export default __webpack_public_path__ + "assets/icons/contact_mobile_whatsApp.201663da.svg";